export const pageHeaderStyles = {
  pageHeader: "m-0 border-0 bg-transparent p-0 shadow-none",
  pageTitle:
    "m-0 font-[family-name:var(--font-family-title)] text-[clamp(1.75rem,4vw,2.25rem)] font-[number:var(--font-weight-regular)] leading-(--line-height-40) text-text-default",
  pageIntro: "[&_p]:m-0 [&_p]:leading-(--line-height-20)",
} as const;
